<script lang="ts">
	import { getContext } from 'svelte';

	import Icon from '../Icon.svelte';
	import type { FlowContainerContext } from '../../types/FlowContainerTypes';

	interface Props {
		pageNumber: number;
		description?: string;
		iconName: string;
		selected?: import('svelte').Snippet;
	}

	let { pageNumber, description = '', iconName, selected }: Props = $props();

	let valid = true;
	let { setPage, currentPage, pages } = getContext<FlowContainerContext>('enzianFlowContainer');

	let active = $derived(pageNumber == $currentPage);
	let done = $derived($currentPage! > pageNumber);
	let firstStep = $derived(pageNumber == 0);
	let lastStep = $derived(pageNumber == $pages.length - 1);

	function handleStepClick() {
		if (pageNumber <= $currentPage!) {
			setPage(pageNumber);
		}
	}
</script>

<div class="flex flex-col container">
	<div class="flex items-center">
		<!-- Stick left -->
		<div
			class:active
			class:done-valid={done && valid}
			class:done-invalid={done && !valid}
			class:invis={firstStep}
			class="flex-grow h-1 bg-gray transition duration-700"
		></div>

		<!-- Bubble -->
		<button
			class="indicator p-2 flex justify-center items-center bg-gray transition duration-700"
			class:active
			class:done-valid={done && valid}
			class:done-invalid={done && !valid}
			onclick={handleStepClick}
		>
			<Icon name={iconName} />
		</button>

		<!-- Stick right -->
		<div
			class="flex-grow h-1 bg-gray transition duration-700"
			class:active
			class:done-valid={done && valid}
			class:done-invalid={done && !valid}
			class:invis={lastStep}
		></div>
	</div>

	<p class="h-8 text-center font-bold">{description}</p>

	{#if selected}
		<div class="flex justify-center">
			{@render selected?.()}
		</div>
	{/if}
</div>

<style>
	.active :global {
		--tw-bg-opacity: 1;
		background-color: rgb(23 137 192 / var(--tw-bg-opacity, 1));
		fill: #fdfdfd;
}

.active :global:where(.dark, .dark *) {
		--tw-bg-opacity: 1;
		background-color: rgb(146 188 220 / var(--tw-bg-opacity, 1));
		fill: #383838;
}

	.done-invalid {
		--tw-bg-opacity: 1;
		background-color: rgb(168 7 39 / var(--tw-bg-opacity, 1));
		fill: #fdfdfd;
}

	.done-valid {
		--tw-bg-opacity: 1;
		background-color: rgb(0 102 0 / var(--tw-bg-opacity, 1));
		fill: #fdfdfd;
}

	.invis {
		background-color: transparent;
}

	.indicator {
		border-radius: 50%;
	}

	.container {
		min-width: 100px;
		max-width: 250px;
	}
</style>
